import { useQuery } from "@tanstack/react-query";
import { getOverview } from "@/api/endpoints";
import { Card, PageTitle } from "@/components/ui/primitives";
import { DataState } from "@/components/data-state";

const labels: Record<string, string> = {
  organizations: "Organizasyon",
  users: "Kullanıcı",
  memberships: "Üyelik",
  companies: "Şirket kaydı",
  tasks: "Görev",
  devices: "Kayıtlı cihaz",
};

export function OverviewPage() {
  const query = useQuery({ queryKey: ["system-overview"], queryFn: getOverview });

  return (
    <div className="space-y-4">
      <PageTitle>Genel bakış</PageTitle>
      <DataState
        isLoading={query.isLoading}
        isError={query.isError}
        isEmpty={false}
        onRetry={() => void query.refetch()}
      >
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-3">
          {Object.entries(query.data ?? {}).map(([key, value]) => (
            <Card key={key} className="p-4">
              <p className="text-2xl font-bold">{value}</p>
              <p className="text-sm text-muted-foreground">{labels[key] ?? key}</p>
            </Card>
          ))}
        </div>
      </DataState>
    </div>
  );
}
